import React, { useEffect, useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import SmuBadge from "../../utils/smu-badge/SmuBadge";
import SmuPdfPreview from "../../utils/smu-pdf-preview/SmuPdfPreview";
import { saveCatalog } from "../../api/catalogs";
import { toast } from "../../helpers/smu-alerts/smu-lerts";

const LoadCatalogs = () => {
  const [pdfUrl, setPdfUrl] = useState("");

  const createSection = (event) => {
    event.preventDefault();
    if (!pdfUrl) return;

    const data = {
      name: "tal",
      items: { url: pdfUrl },
    };
    saveCatalog(data)
      .then(({ error }) => {
        if (!!error) throw new Error("No se pudo guardar el cátalogo.");
        setPdfUrl("");
        toast({ icon: "success", title: "Cátalogo creado." });
      })
      .catch((err) => {
        console.error(err);//toast({ icon: "error", title: err });
      });
  };

  return (
    <Card className="smu-card">
      <Card.Header className="d-flex flex-column py-4">
        <div className="d-flex align-items-center me-auto">
          <SmuBadge color="#CABDFF" />
          <span className="fs-5 ms-3 me-auto">Cargar Catálogo</span>
        </div>
      </Card.Header>
      <Card.Body className="d-flex flex-column px-5">
        <Form
          className="smu-form pb-5"
          onSubmit={(event) => createSection(event)}
        >
          <Row className="d-flex justify-content-center">
            <Form.Group className="col-7">
              <Form.Control
                type="text"
                className="text-primary"
                placeholder="link del catálogo"
                value={pdfUrl}
                onChange={({ target }) => setPdfUrl(target.value)}
              />
            </Form.Group>
            <Col col={12} className="col-2">
              <button
                type="submit"
                className="btn smu-generic-button text-truncate px-3 h-100"
                disabled={!pdfUrl}
              >
                Guardar
              </button>
            </Col>
          </Row>
        </Form>

        <div className="h6 mb-4">Previsualización</div>

        {pdfUrl && <SmuPdfPreview pdf={pdfUrl} />}
      </Card.Body>
    </Card>
  );
};

export default LoadCatalogs;
